import { Directive, OnInit, OnDestroy, Input } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Observable, Subscription } from 'rxjs';

@Directive({
  selector: '[customGridBinding]'
})
export class CustomGridBindingDirective extends DataBindingDirective implements OnInit, OnDestroy {
  @Input() customGridBinding: Observable<any> = null;
  private serviceSubscription: Subscription;

  constructor(grid: GridComponent) {
    super(grid);
  }

  ngOnInit(): void {
    this.serviceSubscription = this.customGridBinding.subscribe((result) => {
      this.grid.data = result;
      this.notifyDataChange();
    });

    super.ngOnInit();
  }

  ngOnDestroy(): void {
    if (this.serviceSubscription) {
      this.serviceSubscription.unsubscribe();
    }

    super.ngOnDestroy();
  }

  rebind(): void {
    /** overload default method with empty implementation */
  }
}
